
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import {
		apiStorageIndex,
		apiStorageSetup,
	} from '@/api/setting'
	@Component({
		components: {},
	})
	export default class Storage extends Vue {
		/** S Data **/
		// 存储方式
		engine = "" // 存储引擎名稱：local-本地，qiniu-七牛云,aliyun-阿里云OSS,qcloud-腾讯云OS:
		form = {
			bucket: '',
			access_key: '',
			secret_key: '',
			domain: '',
			region: '', // 腾讯云需要
			status: 0,
		}

		formRules = {
			bucket: [{
				required: true,
				message: '請輸入存储空间名稱',
				trigger: 'blur'
			}],
			access_key: [{
				required: true,
				message: '請輸入ACCESS_KEY',
				trigger: 'blur'
			}],
			secret_key: [{
				required: true,
				message: '請輸入SECRET_KEY',
				trigger: 'blur'
			}],
			domain: [{
				required: true,
				message: '請輸入空间域名',
				trigger: 'blur'
			}],
			region: [{
				required: true,
				message: '請輸入REGION',
				trigger: 'blur'
			}],
		}
		$refs!: {
			formRef: any
		}
		/** E Data **/

		/** S Methods **/
		onSubmit() {
			// 验证表单格式是否正確
			this.$refs.formRef.validate((valid: boolean): any => {
				if (!valid) return;
				// 請求发送
				 apiStorageSetup({
					...this.form,
					engine: this.engine
				})
				.then((res: any) => {
					setTimeout(() => this.$router.go(-1), 500)			
					//this.$message.success('保存成功!')
				})
				.catch((res: any) => {
					console.log(res)
					//this.$message.error('保存失敗!')
				})
				// setTimeout(()=> {
				// 	this.getStorageIndex()
				// }, 100)
			})
		}

		// 獲取引擎配置
		getStorageIndex() {
			apiStorageIndex({engine: this.engine})
			.then((res: any) => {
				console.log(res)
				this.form = res
			})
			.catch((res: any) => {
				console.log(res)
				//this.$message.error('獲取失敗，請重試!')
			})
		}
		/** E Methods **/
		/** S Life Cycle **/
		created() {
			const query: any = this.$route.query
			if (query.engine) this.engine = query.engine
			this.getStorageIndex()
		}
		/** E Life Cycle **/
	}
